/**
 * chatAlert.js — ทำให้คนรู้ตัวว่ามีคนทักมา
 *
 *   เสียงติ๊ง       สร้างด้วย Web Audio ไม่ต้องมีไฟล์เสียง (ดาวน์โหลดไฟล์บนเครื่องผู้ใช้มีปัญหา)
 *   ชื่อแท็บกะพริบ  ตอนเปิดแท็บอื่นอยู่ — "💬 (3) ข้อความใหม่" สลับกับชื่อเดิม
 *   แจ้งเตือนบนจอคอม ตอนย่อเบราว์เซอร์ไว้ (ต้องกดอนุญาตครั้งแรก)
 *
 * ปิดเสียงได้ จำไว้ในเครื่องของคนนั้น (localStorage) ไม่กระทบคนอื่น
 */

const MUTE_KEY = "chat.muted";

export const isMuted = () => {
  try {
    return localStorage.getItem(MUTE_KEY) === "1";
  } catch {
    return false;
  }
};

export const setMuted = (on) => {
  try {
    localStorage.setItem(MUTE_KEY, on ? "1" : "0");
  } catch {
    // โหมดส่วนตัว/บล็อก storage — ไม่จำก็ไม่เป็นไร
  }
};

// ── เสียงติ๊ง 2 จังหวะ ──────────────────────────────────────────────────────
let audioCtx = null;
export function playDing() {
  if (isMuted()) return;
  try {
    const Ctx = window.AudioContext || window.webkitAudioContext;
    if (!Ctx) return;
    audioCtx = audioCtx || new Ctx();
    // เบราว์เซอร์ยอมให้มีเสียงหลังผู้ใช้เคยคลิกหน้าเว็บแล้วเท่านั้น — ถ้ายังไม่เคย เงียบไปก่อน
    if (audioCtx.state === "suspended") audioCtx.resume().catch(() => {});
    const now = audioCtx.currentTime;
    [[880, 0], [1320, 0.13]].forEach(([freq, at]) => {
      const osc = audioCtx.createOscillator();
      const gain = audioCtx.createGain();
      osc.type = "sine";
      osc.frequency.value = freq;
      gain.gain.setValueAtTime(0.0001, now + at);
      gain.gain.exponentialRampToValueAtTime(0.25, now + at + 0.02);
      gain.gain.exponentialRampToValueAtTime(0.0001, now + at + 0.35);
      osc.connect(gain).connect(audioCtx.destination);
      osc.start(now + at);
      osc.stop(now + at + 0.4);
    });
  } catch {
    // ไม่มีเสียงก็ยังมีการ์ดเด้งกับแท็บกะพริบ
  }
}

// ── ชื่อแท็บกะพริบ ─────────────────────────────────────────────────────────
let flashTimer = null;
let baseTitle = null;
export function flashTitle(unread) {
  if (baseTitle === null) baseTitle = document.title;
  stopFlash(false);
  if (!unread) return;
  let on = false;
  flashTimer = setInterval(() => {
    on = !on;
    document.title = on ? `💬 (${unread}) ข้อความใหม่` : baseTitle;
  }, 1000);
}
export function stopFlash(restore = true) {
  if (flashTimer) clearInterval(flashTimer);
  flashTimer = null;
  if (restore && baseTitle !== null) document.title = baseTitle;
}

// ── แจ้งเตือนบนจอคอม ─────────────────────────────────────────────────────
export const desktopSupported = () => typeof window !== "undefined" && "Notification" in window;
export const desktopPermission = () => (desktopSupported() ? Notification.permission : "unsupported");

export async function askDesktopPermission() {
  if (!desktopSupported()) return "unsupported";
  try {
    return await Notification.requestPermission();
  } catch {
    return Notification.permission;
  }
}

export function desktopNotify({ title, body, onClick }) {
  if (!desktopSupported() || Notification.permission !== "granted") return;
  try {
    const n = new Notification(title, { body, tag: "pagetool-chat", renotify: true });
    n.onclick = () => {
      window.focus();
      onClick?.();
      n.close();
    };
  } catch {
    // บางเบราว์เซอร์ไม่ยอมสร้างนอก service worker — ข้ามไป
  }
}
